import { create } from "zustand";
import { devtools } from "zustand/middleware";

export type RequestId = {
  contactId: number;
  requestDate: string;
};

export type RequestModalOptions = {
  hideContactStep?: boolean;
  // invocato dopo il salvataggio andato a buon fine (non alla chiusura manuale)
  onSuccess?: () => void;
};

// hideContactStep ha senso solo con un contatto gia' noto: senza contactId e' un errore di tipo
type OpenRequestModal = {
  (
    step: number,
    contactId: number,
    companyId?: number,
    requestId?: RequestId,
    options?: RequestModalOptions
  ): void;
  (
    step: number,
    contactId?: null,
    companyId?: number,
    requestId?: RequestId
  ): void;
};

interface RequestModalState {
  isOpen: boolean;
  step: number;
  contactId: number | null;
  hideContactStep: boolean;
  onSuccess: (() => void) | null;
  companyId: number | null;
  requestId: RequestId | null;
  open: OpenRequestModal;
  setStep: (step: number) => void;
  close: () => void;
}

export const useRequestModalStore = create<RequestModalState>()(
  devtools((set) => {
    return {
      isOpen: false,
      step: 0,
      contactId: null,
      hideContactStep: false,
      onSuccess: null,
      companyId: null,
      requestId: null,
      open: (
        step: number,
        contactId?: number | null,
        companyId?: number,
        requestId?: RequestId,
        options?: RequestModalOptions
      ) => {
        set(() => ({
          isOpen: true,
          step,
          contactId: contactId ?? null,
          // anche a runtime il flag vale solo se c'e' un contatto
          hideContactStep: contactId != null && !!options?.hideContactStep,
          onSuccess: options?.onSuccess ?? null,
          companyId: companyId ?? null,
          requestId: requestId ?? null,
        }));
      },
      setStep: (step) => {
        set(() => ({
          step,
        }));
      },
      close: () => {
        set(() => ({
          isOpen: false,
          step: 0,
          contactId: null,
          hideContactStep: false,
          onSuccess: null,
          companyId: null,
          requestId: null,
        }));
      },
    };
  })
);
